import {put, takeLatest, call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    UPDATE_VENUE_STATUSES,
    UPDATE_VENUE_STATUSES_SUCCESS,
    UPDATE_VENUE_STATUSES_ERROR,
}
    from "../../actions/venue";

function* updateVenueStatusesSaga(action) {
    try {
       const data  = yield call(venueService.UpdateVenueStatuses,action.payload)
        
       yield put({
        type: UPDATE_VENUE_STATUSES_SUCCESS,
        payload: data
    });


    } catch (error) {
        yield put({
            type: UPDATE_VENUE_STATUSES_ERROR,error: error.data
        });
    }
}


export function* updateVenueStatusesSagaWatcher() {
    yield takeLatest(UPDATE_VENUE_STATUSES, updateVenueStatusesSaga);
}